const { createReducer } = require("@reduxjs/toolkit");
const { SET_SUGGESTION_MESSAGE } = require("actions/types");

const initialState = {
  activeSuggestion: null,
};

const suggestionReducer = createReducer(initialState, {
  [SET_SUGGESTION_MESSAGE]: (state, action) => {
    state.activeSuggestion = action.payload;
  },
});

export default suggestionReducer;
